import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthInterface } from '../interfaces/interfaces';
import { SettingsProvider } from './settings';
import { UtilsService } from './utils.service';

@Injectable({
	providedIn: 'root'
})
export class AuthService {


	headers:any = null;
	private expiryTimer: any = null;

	constructor(
		private httpClient: HttpClient,
		private router: Router,
    private uService: UtilsService
	) {
		this.restoreSession();
	}

	login(body:any): any{
		console.log(body)
		return this.httpClient.post(SettingsProvider.getUrl('solu-login'), body);
	}

	isLoggedIn(): boolean{
		let auth:any = localStorage.getItem('auth') || '';
		// console.log(this._getToken(auth));
		return this._getToken(auth) !=null;
	}

	ensureAuthenticated(): boolean {
		if (this.shouldBypassAuth()) {
			return true;
		}

		if (!this.isLoggedIn() || this.isTokenExpired()) {
			this.logout('expired');
			return false;
		}
		return true;
	}

	private shouldBypassAuth(): boolean {
		const currentUrl = this.getCurrentPath();
		return currentUrl.startsWith('/auth') || currentUrl.startsWith('/set-password') || currentUrl.startsWith('/documentation') || currentUrl.includes('/error/');
	}

	private getCurrentPath(): string {
		const currentUrl = this.router.url?.toLowerCase() || '';
		if (currentUrl) {
			return currentUrl;
		}
		if (typeof window !== 'undefined') {
			return window.location.pathname.toLowerCase();
		}
		return '';
	}

	private redirectToLogin(): void {
		const currentPath = this.getCurrentPath();
		if (currentPath.startsWith('/auth') || currentPath === '/' || currentPath === '') {
			return;
		}

		const targetUrl = this.router.createUrlTree(['/auth/login']).toString();
		try {
			this.router.navigateByUrl(targetUrl, { replaceUrl: true });
		} catch (error) {
			if (typeof window !== 'undefined') {
				window.location.replace(targetUrl);
			}
		}
	}

	private restoreSession(): void {
		const auth = this.getAuth();
		if (auth?.login && this.getToken()) {
			this.scheduleTokenExpiry();
		}
	}

	private clearExpiryTimer(): void {
		if (this.expiryTimer) {
			clearTimeout(this.expiryTimer);
			this.expiryTimer = null;
		}
	}

	private getTokenExpiryTimestamp(): number | null {
		const auth = this.getAuth();
		if (auth?.expires_in) {
			const expiresAt = Number(auth.expires_in);
			if (Number.isFinite(expiresAt)) {
				return expiresAt;
			}
		}

		const token = this.getToken();
		if (!token) {
			return null;
		}

		try {
			const payload = token.split('.')[1];
			if (!payload) {
				return null;
			}

			const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
			const decodedPayload = decodeURIComponent(escape(atob(normalized)));
			const parsedPayload = JSON.parse(decodedPayload);
			if (parsedPayload?.exp) {
				return Number(parsedPayload.exp) * 1000;
			}
		} catch (error) {
			return null;
		}

		return null;
	}

	private scheduleTokenExpiry(): void {
		this.clearExpiryTimer();
		const expiresAt = this.getTokenExpiryTimestamp();
		if (expiresAt === null) {
			return;
		}

		const now = Date.now();
		const timeLeft = expiresAt - now;

		if (!Number.isFinite(expiresAt) || timeLeft <= 0) {
			this.logout('expired');
			return;
		}

		this.expiryTimer = setTimeout(() => {
			this.logout('expired');
		}, timeLeft);
	}

	isTokenExpired(): boolean {
		const expiresAt = this.getTokenExpiryTimestamp();
		return expiresAt !== null && expiresAt <= Date.now();
	}

	getToken(): string | null{
		let auth:any = localStorage.getItem('auth') || '';
		return this._getToken(auth) || null;
	}

	_getToken(auth: AuthInterface | string): string | null {
		if(auth) {
			let _auth:any = auth;
			if(JSON.parse(_auth)?.login) {
				return JSON.parse(_auth).access_token;
			} else {
				return null;
			}
		} else {
			return null;
		}
	}

	generateRefreshToken(): any{
		let data = {
			access_token: this.getToken(),
			refreshtoken: this.generateRefreshToken()
		}
		return this.httpClient.post(SettingsProvider.getUrl('refresh'), data);
	}

	saveTokens(tokenData :any) {
		let expireDate = new Date().getTime() + (1000 * tokenData['expires_in']);
		const auth:AuthInterface = { login: true, access_token: tokenData['access_token'], refresh_token: tokenData['refresh_token'], expires_in: expireDate };
        localStorage.setItem('auth', JSON.stringify(auth));
		this.scheduleTokenExpiry();
	}

	haveAccess(){
		var loggintoken=localStorage.getItem('access_token')||'';
		var _extractedtoken=loggintoken.split('.')[1];
		var _atobdata=atob(_extractedtoken);
		var _finaldata=JSON.parse(_atobdata);
		if(_finaldata.role=='admin'){
			return true
		} else{
			alert('you not having access');
			return false
		}
	}

	logout(type?: string) {
		this.clearExpiryTimer();
		localStorage.removeItem('auth');
		localStorage.removeItem('user');
		localStorage.clear();
		if(type&&type == 'expired') {
			// alert('Tu sesión a expirado.');
		}
		if(!this.getToken()) {
			setTimeout(() => {
				this.redirectToLogin();
			}, 0);
		}
	}

	successfullOAuthAuthorization(login: boolean, token: string, refreshtoken: string, expires_in: number) {
		let expireDate = new Date().getTime() + (1000 * expires_in);
		const auth:AuthInterface = { login: login, access_token: token, refresh_token: refreshtoken, expires_in: expireDate };
		localStorage.setItem('auth', JSON.stringify(auth));
		this.scheduleTokenExpiry();
	}

	successfullOAuthAuthorizationSimple(login: boolean, token: string, item: string, permissions: any ) {
		const auth:any = { login: login, item: item, access_token: token, refresh_token: token, pm: permissions };
		localStorage.setItem('auth', JSON.stringify(auth));
    this.uService.refreshUserPermissions$.next(true);
		this.scheduleTokenExpiry();
	}

	expiredToken(expirationDate: number) {
		// console.log(expirationDate);
		setTimeout(() => {
			this.logout('expired');
		}, expirationDate);
	}

	checkLogin() {
		// console.log(this.getAuth());
		let auth = this.getAuth();
		if(this.isLoggedIn()) {
			let date = new Date().getTime();
			let expirationDate = new Date(auth.expires_in).getTime();

			this.expiredToken(expirationDate - date);
		}
	}

	getAuth(): any{
		let auth:any = localStorage.getItem('auth') || '';
		return this._getAuth(auth) || null;
	}

	_getAuth(auth: AuthInterface | string): any {
		if(auth) {
			let _auth:any = auth;
			if(JSON.parse(_auth)?.login) {
				return JSON.parse(_auth);
			} else {
				return null;
			}
		} else {
			return null;
		}
	}
}
